import { fieldLabel } from './sharedEnquiryLogic'

// FE3: the shared enquiry settings page's form logic (decisions 6 and 7 of 14/10). The page is Admin only, as the
// two PUTs are (backend requireAdmin = role.showAdmin).

export const VALUE_BASES = [
  { value: 'AVG', label: 'Average' },
  { value: 'MAX', label: 'Highest' },
  { value: 'MIN', label: 'Lowest' }
]

/** The settings rows split as the backend's level says: "bid" = per customer, anything else = the job. */
export function fieldGroups(rows) {
  const list = rows || []
  return [
    { key: 'job', header: 'Enquiry fields', fields: list.filter(r => r.level !== 'bid') },
    { key: 'bid', header: 'Quotation fields', fields: list.filter(r => r.level === 'bid') }
  ]
}

/** A working copy of the rows: the ticks change only this until Save. */
export function toForm(rows) {
  return (rows || []).map(r => ({ fieldKey: r.fieldKey, label: fieldLabel(r), level: r.level, mandatory: r.mandatory === true }))
}

/** The PUT body: only the rows whose tick changed, as fieldKey + mandatory (all the backend reads). */
export function changedFields(form, saved) {
  const before = {}
  ;(saved || []).forEach(r => { before[r.fieldKey] = r.mandatory === true })
  return (form || [])
    .filter(r => before[r.fieldKey] !== r.mandatory)
    .map(r => ({ fieldKey: r.fieldKey, mandatory: r.mandatory }))
}

/** The Admin check the backend makes on the PUTs. */
export function isSettingsAdmin(profile) {
  return !!(profile && profile.role && profile.role.showAdmin)
}
